import { MessagingChannel } from 'jschannel';
import { StatementOptions, VERB_ID } from '@/components/C1Opener/OpenerTypes';
import { sendMessageToContainer } from '@/components/C1Opener/SendMessageUtils';

/*
Duration MUST be lower than 60,000 because it should fire no slower
than every 60 seconds, and it re-zeroes on our side after each send.
 */
export async function sendExperiencedStatement(
    channel: MessagingChannel,
    contentId: string,
    duration: number,
    options?: StatementOptions
): Promise<unknown> {
    const verbId = options?.verbId ?? VERB_ID;
    return sendMessageToContainer(channel, 'newStatements', [
        {
            verb: {
                id: `${verbId}/experienced`,
                display: {
                    und: 'experienced'
                }
            },
            object: {
                id: contentId
            },
            result: {
                duration: duration
            }
        }
    ]);
}